// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CompanySearch.module.css */
.CompanySearch_searchInput__Nquu1 {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.CompanySearch_errorText__QgbMR {
  color: red;
}

.CompanySearch_searchResults__LpqEt {
  position: absolute;
  width: 100%;
  overflow: auto;
  margin-top: 10px;
  border: 1px solid #ccc;
  background-color: #fff;
  z-index: 10;
}

.CompanySearch_company__PnGu5 {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
  background-color: #fff;
}

.CompanySearch_company__PnGu5:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/CompanySearch/CompanySearch.module.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* CompanySearch.module.css */\n.searchInput {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.errorText {\n  color: red;\n}\n\n.searchResults {\n  position: absolute;\n  width: 100%;\n  overflow: auto;\n  margin-top: 10px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  z-index: 10;\n}\n\n.company {\n  padding: 10px;\n  border-bottom: 1px solid #ccc;\n  cursor: pointer;\n  background-color: #fff;\n}\n\n.company:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchInput": `CompanySearch_searchInput__Nquu1`,
	"errorText": `CompanySearch_errorText__QgbMR`,
	"searchResults": `CompanySearch_searchResults__LpqEt`,
	"company": `CompanySearch_company__PnGu5`
};
export default ___CSS_LOADER_EXPORT___;
